export const SELECTORS = {
  OPTION_ANSWER_LABEL: '.lrn-label',
  OPTION_ANSWER_INPUT: 'input.lrn-input',
  OPTION_ANSWER: 'li.lrn-mcq-option',
  OPTION_ANSWER_LIST: 'ul.lrn_mcqgroup',
  QUESTION: '.lrn_question',
  QUESTION_ANSWER_WRAPPER: '.lrn_response_wrapper',
  QUESTION_RESPONSES: '.lrn_response',
  //@note - do not change the order for this array
  TWO_COLUMNS: [
    ['.col-xs-12.col-sm-6:nth-child(1)', '.col-xs-12.col-sm-6:nth-child(2)'],
    ['.col-xs-12.col-sm-6:nth-child(1)', '.col-xs-12.col-sm-6:nth-child(3)'],
    ['.col-xs-6:nth-child(1)', '.col-xs-6:nth-child(2)'],
    ['.col-xs-6:nth-child(1)', '.col-xs-6:nth-child(3)'],
    [
      ':not([class])[data-lrn-widget-type="feature"]',
      ':not([class])[data-lrn-widget-type="question"]',
    ],
    [
      '.two-columns.left-column[data-lrn-widget-type="feature"]',
      '.two-columns.right-column[data-lrn-widget-type="question"]',
    ],
    // @note - this item is in testing, could cause two col rendering issues
    //has to stay on the last position in this array
    [
      ':not([class])[data-lrn-widget-type="feature"]',
      '[data-lrn-widget-type="question"]',
    ],
  ],
  INNER_CONTAINER: '.bluebook-player-inner-container',
  ANNOTATION_DISABLED: 'annotation-disabled-highlight',
  HIGHLIGHTED_ELEMENT: 'x-marker[data-is-highlight-node="true"]',
  HIGHLIGHT_BUTTON:
    'div.lrn-annotations-c-popover button.lrn-annotations-c-button--highlight',
  EXPAND_COLORS_BUTTON:
    'div.lrn-annotations-c-popover button.lrn-annotations-c-button--togglePalette',
  REMOVE_HIGHLIGHT_BUTTON:
    'div.lrn-annotations-c-popover button.lrn-annotations-c-button--removeHighlight',
  COLOR_BUTTON: (color) =>
    `div.lrn-annotations-c-popover ul.lrn-annotations-c-popover__palette li button.lrn-annotations-c-button.lrn-annotations-color--${color}`,
  ANNOTATION_POPOVER_CONTAINER: 'div.lrn-annotations-c-popover',
  CROSSOUT_CONTAINER: '.crossout-container',
  XMARKER_ELEMENT: 'lrn-annotations-texthighlight-marking',
  SELECTED_ANNOTATION: 'selected-annotation',
  CAN_ANNOTATE: 'can-annotate',
  TWO_COLUMNS_WRAPPER_CLASS: 'two-columns-wrapper',
  REVIEW_PAGE: '.bluebook-review-page',
  FRQ_CONTAINER_EDITOR: '.lrn_response_input_wrapper',
  SHARED_PASSAGE: '.lrn_sharedpassage',
  SHARED_PASSAGE_CONTAINER: 'div.lrn_sharedpassage',
  SHARED_PASSAGE_TITLE: 'div.lrn_sharedpassage p#custom-shared-passage-info',
  QUESTION_WIDGET: '[data-lrn-widget-type="question"]',
  FEATURE_WIDGET: '[data-lrn-widget-type="feature"]',
  QUESTION_MASK: '.question-content-mask',
  ANCHOR_LINK: '.dap_reference_link',
};

export const MODAL_ROOT = '.modal-root';
export const MODAL_INNER_ROOT = '.modal-inner-root';
